import { Form } from "antd"
import { useContext, useState } from "react"
import BaseInputField from "../../../components/elements/BaseInputField"
import BaseModal from "../../../components/layout/BaseModal"
import { ModalContext } from "../../../components/contexts/ModalContext"

type AddTourModalType = {
    modalId: number
    onSave: (name: string) => void
}

export default function AddTourModal(props: AddTourModalType) {
    const [form] = Form.useForm()
    const modalCon = useContext(ModalContext)
    const [name, setName] = useState("")

    return (
        <Form
            form={form}
            onFinish={() => {
                if (!name.trim()) return
                props.onSave(name.trim())
                setName("")
                form.resetFields()
                modalCon?.trigger(props.modalId)
            }}>
            <BaseModal
                modalId={props.modalId}
                size="fit"
                title="Tour anlegen"
                bottomRow={
                    <div className="flex justify-end w-full">
                        <Form.Item className="mb-0">
                            <button className="btn btn-primary" type="submit" disabled={!name.trim()}>
                                Anlegen
                            </button>
                        </Form.Item>
                    </div>
                }>
                <p className="text-sm text-gray-500 px-2 pt-4 pb-2">Wöchentlicher Fahrplan (Mo–Fr). Mitarbeiter und Objekte legen Sie danach in der Tour fest.</p>
                <Form.Item className="mb-2" name="name" rules={[{ required: true, message: "Bitte ausfüllen!" }]}>
                    <BaseInputField label="Name *" type="text" placeholder="z. B. Chemnitz Nord" onChange={setName} />
                </Form.Item>
            </BaseModal>
        </Form>
    )
}
